export const FREIGHT_ANALYTICS_CAPACITY_MATCHES_FETCHED =
  'FREIGHT_ANALYTICS_CAPACITY_MATCHES_FETCHED';
export const FREIGHT_ANALYTICS_SHIPMENT_IMPRESSIONS_FETCHED =
  'FREIGHT_ANALYTICS_SHIPMENT_IMPRESSIONS_FETCHED';
export const FREIGHT_ANALYTICS_SHIPMENT_REJECTIONS_FETCHED =
  'FREIGHT_ANALYTICS_SHIPMENT_REJECTIONS_FETCHED';
export const FREIGHT_ANALYTICS_SHIPMENT_CLAIMS_FETCHED =
  'FREIGHT_ANALYTICS_SHIPMENT_CLAIMS_FETCHED';
export const FREIGHT_ANALYTICS_SHIPMENT_VIEWS_FETCHED = 'FREIGHT_ANALYTICS_SHIPMENT_VIEWS_FETCHED';
